import { CpRefundsResponseInterface } from '../../../interfaces/response/refunds/cp-refunds-response-interface';
import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';
import { CpRefundsItemListResponseModel } from './refunds-item-list/cp-refunds-item-list-response-model';

export class CpRefundsResponseModel implements CpRefundsResponseInterface {
  Refunds: CpRefundsItemListResponseModel[] = new Array<CpRefundsItemListResponseModel>();
  PaginationResult: PaginationModel = new PaginationModel();

  constructor(init?: Partial<CpRefundsResponseModel>) {
    Object.assign(this, init);
  }
}
